import React, { useEffect } from "react";

const StripePricingTable = () => {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://js.stripe.com/v3/pricing-table.js";
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return React.createElement("stripe-pricing-table", {
        "pricing-table-id": "prctbl_1OqNxkBoW87y8wvslHj8hVJN",
        "publishable-key": "pk_live_51NyizxBoW87y8wvsHBOIoqKqkgENlNeF7TQuW503IBiIwvPgg9aMvqTMHvGsrJbCn14FqsaCFmTZKixv6mUFXnBP005DSq26Kq",
    });
};
export default StripePricingTable;